import { takeLatest, select, call, put } from 'redux-saga/effects';

import { signingIn } from '../actions';
import { DO_SIGN_IN } from '../constants/actionTypes';
import { isEmptyObject } from '../lib/helpers';
import { userSelector } from '../reducers/selectors';
import AuthService from '../services/AuthService';

const signIn = () => {
  const loginService = new AuthService();
  loginService.login();
};

function* userWatcher() {
  yield takeLatest(DO_SIGN_IN, userWorker);
}

function* userWorker() {
  const user = yield select(userSelector);
  const { signingIn: isSigningIn, profile } = user;

  if (!isSigningIn && isEmptyObject(profile)) {
    yield put(signingIn());
    yield call(signIn);
  }
}

export { userWorker, signIn };
export default userWatcher;
